module.exports = __webpack_public_path__ + "static/media/logo_romagna.b1ebf539.webp";